import { schema } from 'normalizr';

const facebookAppSchema = new schema.Entity('facebookApps', {
  //
});

export default facebookAppSchema;
